import { withFormik } from 'formik'
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose'

import { required } from 'utils/validation'
import { FORM_ACTION_ERROR_STATUS, FORM_PROGRESS_STATUS, FORM_SUBMIT_STATUS } from 'constants/form'

export default compose(
  withFormik({
    // Transform outer props into form values
    mapPropsToValues: () => ({ name: '', image: null }),
    // Add a custom validation function (this can be async too!)
    validate: ({ name }) => {
      const errors = {}

      if (required(name)) {
        errors.name = 'Please enter a valid project name'
      }

      return errors
    },
    enableReinitialize: true,
    validateOnChange: false,
    handleSubmit: (values, {
      props, setSubmitting,
    }) => {
      setSubmitting(true)
      // If form has no error
      if (props.onFormSubmit) {
        props.onFormSubmit(values)
      }
      // props.actions.loginUser(values)
    },
  }),
  withStateHandlers(
    ({
      initialRememberMe = false
    }) => ({
      rememberMe: initialRememberMe
    }),
    {
      toggleCheckbox: () => event => ({
        rememberMe: event.target.checked
      }),
    }
  ),
  // Handlers
  withHandlers({
    handleFieldChange: props => (event) => {
      // test
      props.setStatus(FORM_PROGRESS_STATUS)
      props.handleChange(event)
    },
    handleImageRemoved: props => () => {
      props.setFieldValue('image', null, true)
    },
    handleImageChange: props => (acceptedFile) => {
      if (acceptedFile) {
        props.setFieldValue('image', acceptedFile, true)
      }
    },
    handleFormSubmit: props => (event) => {
      props.setStatus(FORM_SUBMIT_STATUS)
      props.handleSubmit(event)
    },
    handleCheckboxChange: props => (event) => {
      props.setFieldValue('rememberMe', event.target.checked)
      props.toggleCheckbox(event)
    },
    hasFieldError: props => (fieldName) => {
      return !!((props.errors[fieldName] && props.errors[fieldName].length && props.status === FORM_SUBMIT_STATUS))
    },
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        apiCallError, setStatus, setSubmitting
      } = this.props
      // trigger when error occured during login
      if (prevProps.apiCallError !== apiCallError && apiCallError) {
        setStatus(FORM_ACTION_ERROR_STATUS)
        setSubmitting(false)
      }
    },

  })
)




// WEBPACK FOOTER //
// ./src/components/organisms/CreateOrganisationForm/CreateOrganisationForm.enhancer.js